import { put, post, get } from '@/utils/httpHelper';

module.exports = {
  async modifiedStakeholderUnsubscribe (stakeholderId) {
    const url = `/esg/stakeholder/modifiedUnsubscribe/${stakeholderId}`;
    const body = await put(url);
    return body.data;
  },
  async checkStakeholderInfo (params) {
    const url = `/esg/stakeholder/check`;
    const body = await post(url, params);
    return body.data;
  },
  async findAllActiveInfo () {
    const url = `/esg/security/stakeholder/findAllActive`;
    const body = await get(url);
    return body.data;
  },
  async findActiveStakeholder (currentPage, pageSize) {
    const url = `/esg/security/stakeholder/findActiveStakeholder/${currentPage}/${pageSize}`;
    const body = await get(url);
    return body.data;
  },
  async saveStakeholderInfo (params, isAdd) {
    const url = `/esg/security/stakeholder/saveStakeholder/${isAdd}`;
    const body = await post(url, params);
    return body.data;
  },
  async findStakeholderInfoByConditions (params) {
    const url = `/esg/security/stakeholder/findByConditions`;
    const body = await get(url, params);
    return body.data;
  },
  async findSearchConditions (activeType) {
    const url = `/esg/security/stakeholder/findSearchConditions/${activeType}`;
    const body = await get(url);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/stakeholder.repository.js